const BASE_URL = '/discovery';
// API
const API_BASE_URL = `${ BASE_URL }/api`;
const API_AUTHOR_BASE_URL = `${ API_BASE_URL }/author`;
const API_LIBRARY_BASE_URL = `${ API_BASE_URL }/library`;
// APP
const APP_AUTHOR_BASE_URL = `${ BASE_URL }/author`;
const APP_LIBRARY_BASE_URL = `${ BASE_URL }/library`;

const URLS = Object.freeze({
  actionCable: process.env.ACTION_CABLE_URL,
  api: {
    account: `${ API_BASE_URL }/account`,
    accounts: `${ API_BASE_URL }/accounts`,
    accountSettings: {
      newBookPeriodicity: `${ API_BASE_URL }/account_settings/new_books_periodicities`,
      notificationsDigestPeriodicity: `${ API_BASE_URL }/account_settings/notifications_digest_periodicities`,
      settings: `${ API_BASE_URL }/account_settings`,
    },
    activityFeed: {
      bookActivities: `${ API_BASE_URL }/book/<book-slug>/activities`,
      bookActivitiesCount: `${ API_BASE_URL }/book/<book-slug>/activities/count`,
      bookMentions: `${ API_BASE_URL }/book/<book-slug>/mentions`,
      bookMentionsCount: `${ API_BASE_URL }/book/<book-slug>/mentions/count`,
      feed: `${ API_BASE_URL }/user/feed`,
      feedPost: `${ API_BASE_URL }/user/feed/<post-slug>`,
      pickPostOption: `${ API_BASE_URL }/post/<post-slug>/pick_option`,
      postReportReasons: `${ API_BASE_URL }/activity_report_reasons`,
      postUpvote: `${ API_BASE_URL }/post/<post-slug>/upvote`,
      postUpvotes: `${ API_BASE_URL }/post/<post-slug>/upvotes`,
      reportPost: `${ API_BASE_URL }/post/<post-slug>/report`,
      sidebarFeed: `${ API_BASE_URL }/user/sidebar_feed`,
      userActivities: `${ API_BASE_URL }/user/<user-id>/activities`,
    },
    amazon: {
      bookPurchaseUrl: `${ API_BASE_URL }/amazon_purchase_urls/<book-slug>`,
      storesList: `${ API_BASE_URL }/amazon_stores`,
    },
    amazonPurchaseUrl: `${ API_BASE_URL }/amazon_purchase_urls/<book-slug>`,
    amazonStores: `${ API_BASE_URL }/amazon_stores`,
    applicationRequests: `${ API_BASE_URL }/application_requests`,
    author: {
      book: `${ API_AUTHOR_BASE_URL }/books/<book-slug>`,
      bookDrafts: `${ API_AUTHOR_BASE_URL }/book_drafts`,
      bookInSeriesAttachments: `${ API_AUTHOR_BASE_URL }/book_in_series_attachments`,
      bookSubmissionCoupons: `${ API_AUTHOR_BASE_URL }/book_submission_coupons/<coupon-code>`,
      bookSubmissionPayments: `${ API_AUTHOR_BASE_URL }/book_submission_payments`,
      books: `${ API_AUTHOR_BASE_URL }/books`,
      cancelBookReview: `${ API_AUTHOR_BASE_URL }/books/<book-slug>/cancel`,
      epubAttachments: `${ API_AUTHOR_BASE_URL }/epub_attachments`,
      feedback: `${ API_AUTHOR_BASE_URL }/books/<book-slug>/feedback`,
      mobiAttachments: `${ API_AUTHOR_BASE_URL }/mobi_attachments`,
      illustrationAttachments: `${ API_AUTHOR_BASE_URL }/illustration_attachments`,
      images: `${ API_AUTHOR_BASE_URL }/images`,
      pdfAttachments: `${ API_AUTHOR_BASE_URL }/pdf_attachments`,
      relistBook: `${ API_AUTHOR_BASE_URL }/books/<book-slug>/relist`,
      removeBook: `${ API_AUTHOR_BASE_URL }/books/<book-slug>/remove`,
      reportReview: `${ API_AUTHOR_BASE_URL }/books/<book-slug>/review_report`,
      reportReviewReasons: `${ API_AUTHOR_BASE_URL }/review_report_reasons`,
      resubmitBook: `${ API_AUTHOR_BASE_URL }/books/<book-slug>/resubmit`,
    },
    book: {
      addDownvote: `${ API_BASE_URL }/book_downvotes/?id=<book-slug>`,
      addUpvote: `${ API_BASE_URL }/book_upvotes/?id=<book-slug>`,
      removeDownvote: `${ API_BASE_URL }/book_downvotes/<book-slug>`,
      removeUpvote: `${ API_BASE_URL }/book_upvotes/<book-slug>`,
      userReviews: `${ API_BASE_URL }/book/<book-slug>/user_reviews`,
      userReviewsCount: `${ API_BASE_URL }/book/<book-slug>/user_reviews/count`,
    },
    books: `${ API_BASE_URL }/books`,
    booksByUrl: `${ API_BASE_URL }/books_by_url?url=<book-url>`,
    comments: {
      book: {
        comment: `${ API_BASE_URL }/books/<book-slug>/comments/<comment-id>`,
        commentUpvote: `${ API_BASE_URL }/books/<book-slug>/comments/<comment-id>/upvote`,
        commentUpvotes: `${ API_BASE_URL }/books/<book-slug>/comments/<comment-id>/upvotes`,
        comments: `${ API_BASE_URL }/books/<book-slug>/comments`,
        commentsCount: `${ API_BASE_URL }/books/<book-slug>/comments/count`,
        reportComment: `${ API_BASE_URL }/books/<book-slug>/comments/<comment-id>/report`,
      },
      commentReportReasons: `${ API_BASE_URL }/comment_report_reasons`,
      post: {
        comment: `${ API_BASE_URL }/post/<post-slug>/comments/<comment-id>`,
        commentUpvote: `${ API_BASE_URL }/post/<post-slug>/comments/<comment-id>/upvote`,
        commentUpvotes: `${ API_BASE_URL }/post/<post-slug>/comments/<comment-id>/upvotes`,
        comments: `${ API_BASE_URL }/post/<post-slug>/comments`,
        commentsCount: `${ API_BASE_URL }/post/<post-slug>/comments/count`,
        reportComment: `${ API_BASE_URL }/post/<post-slug>/comments/<comment-id>/report`,
      },
      userReview: {
        comment: `${ API_BASE_URL }/user_review/<slug>/comments/<comment-id>`,
        commentUpvote: `${ API_BASE_URL }/user_review/<slug>/comments/<comment-id>/upvote`,
        commentUpvotes: `${ API_BASE_URL }/user_review/<slug>/comments/<comment-id>/upvotes`,
        comments: `${ API_BASE_URL }/user_review/<slug>/comments`,
        commentsCount: `${ API_BASE_URL }/user_review/<slug>/comments/count`,
        reportComment: `${ API_BASE_URL }/user_review/<slug>/comments/<comment-id>/report`,
      },
    },
    genres: {
      all: `${ API_BASE_URL }/genres`,
      featured: `${ API_BASE_URL }/featured_genres`,
      popular: `${ API_BASE_URL }/popular_genres`,
    },
    invitations: {
      sentReviewerInvitations: `${ API_BASE_URL }/user/reviewer_invitations`,
      createInvitations: `${ API_BASE_URL }/user/reviewer_invitations`,
    },
    followers: {
      followBulk: `${ API_BASE_URL }/bulk_follow`,
      followUser: `${ API_BASE_URL }/user/<user-id>/follow`,
      followSuggestions: `${ API_BASE_URL}/follow_suggestions`,
      followSuggestionsSearch: `${ API_BASE_URL}/follow_suggestions/search`,
      follows: `${ API_BASE_URL }/user/<user-id>/follows`,
      followsCount: `${ API_BASE_URL }/user/<user-id>/follows_count`,
      followers: `${ API_BASE_URL }/user/<user-id>/followers`,
      followersCount: `${ API_BASE_URL }/user/<user-id>/followers_count`,
    },
    leaderboard: `${ API_BASE_URL }/leaderboard`,
    directories: `${ API_BASE_URL }/directories`,
    library: {
      acceptDirectSubmission: `${ API_LIBRARY_BASE_URL }/direct_submissions/<book-slug>/accept`,
      bookshelf: {
        entries: `${ API_LIBRARY_BASE_URL }/bookshelf`,
        track: `${ API_LIBRARY_BASE_URL }/bookshelf/track`,
        entry: `${ API_LIBRARY_BASE_URL }/bookshelf/<entry-slug>`,
        markAsCurrentlyReading: `${ API_LIBRARY_BASE_URL }/bookshelf/<entry-slug>/mark_as_currently_reading`,
        markAsRead: `${ API_LIBRARY_BASE_URL }/bookshelf/<entry-slug>/mark_as_read`,
        markAsWantToRead: `${ API_LIBRARY_BASE_URL }/bookshelf/<entry-slug>/mark_as_want_to_read`,
      },
      cancelReview: `${ API_LIBRARY_BASE_URL }/in_progress_reviews/<book-slug>/cancel`,
      cancelSkipBook: `${ API_LIBRARY_BASE_URL }/skip_book?id=<book-slug>`,
      canceledReviews: `${ API_LIBRARY_BASE_URL }/canceled_reviews`,
      counters: `${ API_LIBRARY_BASE_URL }/counters`,
      dashboard: `${ API_LIBRARY_BASE_URL }/dashboard`,
      denyDirectSubmission: `${ API_LIBRARY_BASE_URL }/direct_submissions/<book-slug>/deny`,
      didNotFinishReasons: `${ API_LIBRARY_BASE_URL }/canceled_review_reasons`,
      directSubmissions: `${ API_LIBRARY_BASE_URL }/direct_submissions`,
      formats: `${ API_LIBRARY_BASE_URL }/formats`,
      inProgressReviews: `${ API_LIBRARY_BASE_URL }/in_progress_reviews`,
      publishReview: `${ API_LIBRARY_BASE_URL }/in_progress_reviews/<book-slug>/publish`,
      publishUserReview: `${ API_LIBRARY_BASE_URL }/user_reviews/<slug>/publish`,
      readingGoal: `${ API_LIBRARY_BASE_URL }/reading_goal`,
      reportSpam: `${ API_LIBRARY_BASE_URL }/book_reports`,
      reportSpamReasons: `${ API_LIBRARY_BASE_URL }/book_report_reasons`,
      restoreDirectSubmission: `${ API_LIBRARY_BASE_URL }/direct_submissions/<book-slug>/restore`,
      review: `${ API_LIBRARY_BASE_URL }/reviews/<book-slug>`,
      reviews: `${ API_LIBRARY_BASE_URL }/reviews`,
      skipBook: `${ API_LIBRARY_BASE_URL }/skip_book`,
      tips: `${ API_LIBRARY_BASE_URL }/tips`,
      userReview: `${ API_LIBRARY_BASE_URL }/user_reviews/<slug>`,
      userReviews: `${ API_LIBRARY_BASE_URL }/user_reviews`,
    },
    mentions: `${ API_BASE_URL }/mentions?term=<term>`,
    notifications: {
      markAllAsRead: `${ API_BASE_URL }/user/notifications/mark_all_as_read`,
      markAsRead: `${ API_BASE_URL }/user/notifications/<notification-id>/mark_as_read`,
      notifications: `${ API_BASE_URL }/user/notifications`,
      unread: `${ API_BASE_URL }/user/notifications/unread`,
    },
    profilePopup: `${ API_BASE_URL }/popups/<user-id>`,
    reminders: {
      reminders: `${ API_BASE_URL }/user/reminders`,
      snooze: `${ API_BASE_URL }/user/reminders/<reminder-type>/snooze`,
    },
    reviewers: {
      entries: `${ API_BASE_URL }/reviewers`,
      autocompleteName: `${ API_BASE_URL }/reviewers/autocomplete?query=<term>`,
    },
    search: `${ API_BASE_URL }/search?term=<term>`,
    session: `${ API_BASE_URL }/session`,
    signUp: `${ API_BASE_URL }/signup`,
    socialAccounts: {
      consumers: `${ API_BASE_URL }/user/consumers`,
      facebook: `${ API_BASE_URL }/user/facebook_consumer`,
      goodreads: `${ API_BASE_URL }/user/goodreads_consumer`,
      twitter: `${ API_BASE_URL }/user/twitter_consumer`,
    },
    stripeAccount: `${ API_BASE_URL }/user/stripe_account`,
    tipPayments: `${ API_BASE_URL }/tip_payments`,
    tips: {
      create: `${ API_BASE_URL }/tips`,
      given: `${ API_BASE_URL }/user/tips`,
      givenForBook: `${ API_BASE_URL }/user/tips/<book-slug>`,
    },
    user: `${ API_BASE_URL }/user`,
    userId: `${ API_BASE_URL }/user_id`,
    userBookshelf: `${ API_BASE_URL }/user/<user-id>/bookshelf`,
    userGenres: {
      all: `${ API_BASE_URL }/user/genres`,
      saveBulk: `${ API_BASE_URL }/user/bulk_genres`,
      secondLevel: `${ API_BASE_URL }/user/second_level_genres`,
    },
    goodreadsImport: `${ API_BASE_URL }/user/goodreads_import`,
    userReviews: {
      upvote: `${ API_BASE_URL }/user_review/<slug>/upvote`,
      upvotes: `${ API_BASE_URL }/user_review/<slug>/upvotes`,
    },
    verdicts: `${ API_BASE_URL }/verdicts`,
    wordCountOptions: `${ API_BASE_URL }/books/word_counts`,
  },

  app: {
    about: {
      terms: `${ BASE_URL }/about/terms`,
    },
    accountSettings: `${ BASE_URL }/account-settings/edit`,
    author: {
      guidelines: `${ APP_AUTHOR_BASE_URL }/submission-guidelines`,
      submissions: `${ APP_AUTHOR_BASE_URL }/submissions`,
      feedback: `${ APP_AUTHOR_BASE_URL }/submissions/<book-slug>/feedback/new`,
      viewFeedback: `${ APP_AUTHOR_BASE_URL }/submissions/<book-slug>/feedback`,
    },
    book: `${ BASE_URL }/book/<book-slug>`,
    bookUserReviews: `${ BASE_URL }/book/<book-slug>/user-reviews`,
    discover: `${ BASE_URL }/books`,
    feed: `${ BASE_URL }/feed`,
    followers: {
      followers: `${ BASE_URL }/user/<user-id>/followers`,
      following: `${ BASE_URL }/user/<user-id>/following`,
    },
    genre: `${ BASE_URL }/<genre-id>`,
    home: BASE_URL,
    leaderboard: `${ BASE_URL }/leaderboard`,
    directories: `${ BASE_URL }/directories`,
    library: {
      applyForReviewer: `${ BASE_URL }/reviewers`,
      bookshelf: `${ APP_LIBRARY_BASE_URL }/bookshelf`,
      bookshelfCurrentlyReading: `${ APP_LIBRARY_BASE_URL }/bookshelves/currently-reading`,
      bookshelfRead: `${ APP_LIBRARY_BASE_URL }/bookshelves/read`,
      bookshelfReviewed: `${ APP_LIBRARY_BASE_URL }/reviews`,
      bookshelfWantToRead: `${ APP_LIBRARY_BASE_URL }/bookshelves/want-to-read`,
      currentlyReviewing: `${ APP_LIBRARY_BASE_URL }/reviewing`,
      createUserReview: `${ APP_LIBRARY_BASE_URL }/user-reviews/new?bookshelf_entry_id=<bookshelf-entry-slug>`,
      dashboard: `${ APP_LIBRARY_BASE_URL }/dashboard`,
      editReview: `${ APP_LIBRARY_BASE_URL }/reviews/<book-slug>/edit`,
      editUserReview: `${ APP_LIBRARY_BASE_URL }/user-reviews/<bookshelf-entry-slug>/edit`,
      faq: `${ BASE_URL }/reviewers-faq`,
      guidelines: `${ APP_LIBRARY_BASE_URL }/reviewer-guidelines`,
      tips: `${ APP_LIBRARY_BASE_URL }/tips`,
    },
    notifications: `${ BASE_URL }/notifications`,
    reviewerInvitations: `${ BASE_URL }/reviewer-invitations`,
    signIn: `${ BASE_URL }/auth/sign_in`,
    signOut: `${ BASE_URL }/sign_out.json`,
    signUp: {
      facebook: `${ BASE_URL }/auth/social_sign_in/facebook`,
      google: `${ BASE_URL }/auth/social_sign_in/google`,
      regular: `${ BASE_URL }/signup`,
    },
    thankYouForSigningUp: `${ BASE_URL }/confirmation`,
    tips: `${ BASE_URL }/tips`,
    userProfile: {
      entry: `${ BASE_URL }/user/<username>`,
      edit: `${ BASE_URL }/user/edit`,
    },
  },

  external: {
    amazon: {
      books: 'https://amazon.com/books',
    },
    apple: {
      books: 'https://www.apple.com/apple-books/',
    },
    authorizeFacebook: `${ BASE_URL }/oauth2/facebook/authorize`,
    authorizeGoodreads: `${ BASE_URL }/oauth/goodreads/authorize`,
    authorizeTwitter: `${ BASE_URL }/oauth/twitter/authorize`,
    blog: {
      howToWriteABookReview: 'https://reedsy.com/discovery/blog/how-to-write-a-book-review',
    },
    google: {
      playBooks: 'https://play.google.com/store/books',
    },
    reedsy: {
      marketplace: 'https://reedsy.com',
    },
    stripe: {
      authorize: `${ BASE_URL }/stripe_connect/authorize`,
      home: 'https://stripe.com',
      dashboard: 'https://dashboard.stripe.com',
    },
  },
});

export default URLS;
